import {
  Box,
  Group,
  rem,
  Skeleton,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { CATEGORY_LABELS, CATEGORY_ORDER, useInputStyles } from "../../utils";
import classes from "./index.module.css";

// Textos fixos do catálogo já aparecem no skeleton — só o que depende de dados
// (contagem dos filtros e os cards) permanece como Skeleton. A primeira chip
// ("Todas") reflete o filtro padrão (filter === "all") do CatalogGrid.
const FILTER_LABELS = [
  "Todas",
  ...CATEGORY_ORDER.map((cat) => CATEGORY_LABELS[cat]),
];

/**
 * Um card do catálogo, com a mesma moldura do real (a classe `.card` traz
 * borda, raio, respiro e a altura mínima) e o mesmo empilhamento: logo, nome,
 * fornecedor, descrição e ação. Como retângulo único ele ficava 40px mais
 * baixo que o card de verdade e não dizia nada sobre o que ia aparecer.
 */
function CardEsqueleto() {
  return (
    <Box className={classes.card}>
      <Skeleton
        height={rem(44)}
        width={rem(44)}
        radius="md"
      />
      <Stack gap={rem(6)}>
        <Skeleton
          height={rem(16)}
          width="62%"
          radius="sm"
        />
        <Skeleton
          height={rem(12)}
          width="48%"
          radius="sm"
        />
      </Stack>
      <Stack gap={rem(7)}>
        <Skeleton
          height={rem(13)}
          radius="sm"
        />
        <Skeleton
          height={rem(13)}
          width="88%"
          radius="sm"
        />
        <Skeleton
          height={rem(13)}
          width="64%"
          radius="sm"
        />
      </Stack>
      <Skeleton
        height={rem(36)}
        radius="md"
        mt="auto"
      />
    </Box>
  );
}

/** Esqueleto de carregamento do catálogo — mantém o mesmo grid do CatalogGrid. */
export function CatalogGridSkeleton() {
  const inputStyles = useInputStyles();

  return (
    <Stack gap="1.25rem">
      <Group
        justify="space-between"
        align="flex-end">
        <Stack gap={2}>
          <Text
            ff="heading"
            fw={700}
            fz="1.75rem"
            className={classes.textMain}>
            Integrações
          </Text>
          <Text
            size="sm"
            className={classes.textMuted}>
            Conecte sistemas externos para que seu agente possa agir em outras
            ferramentas durante o atendimento.
          </Text>
        </Stack>
        <TextInput
          placeholder="Buscar integração..."
          leftSection={<IconSearch size={14} />}
          size="sm"
          w="16.25rem"
          styles={inputStyles}
          disabled
        />
      </Group>

      <Group
        gap="0.5rem"
        wrap="wrap">
        {FILTER_LABELS.map((label, index) => (
          <Box
            key={label}
            className={classes.chip}
            data-active={index === 0}>
            {label}
            {/* Contagem é dinâmica (depende do catálogo) → placeholder. */}
            <Skeleton
              height={14}
              width={16}
              radius="xl"
            />
          </Box>
        ))}
      </Group>

      <Box className={classes.grid}>
        {Array.from({ length: 6 }).map((_, index) => (
          <CardEsqueleto key={index} />
        ))}
      </Box>
    </Stack>
  );
}
